window.addEventListener('load', function (event) {
	const thumbsEternally = new Swiper('.tabbedContentEternallyPink__tab-titles', {
		wrapperClass: 'tabbedContentEternallyPink__tab-titles-track',
		slideClass: 'tabbedContentEternallyPink__tab-title',
		speed: 500,
		slidesPerView: 'auto',
		watchSlidesProgress: true,
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true
		}
	});

	const tabGallery = new Swiper('.tabbedContentEternallyPink__tab-gallery', {
		wrapperClass: 'tabbedContentEternallyPink__tab-track',
		slideClass: 'tabbedContentEternallyPink__tab-item',
		speed: 500,
		thumbs: {
			autoScrollOffset: 0,
			swiper: thumbsEternally,
		}
	});
}, false);